import type { SortOrder } from 'antd/es/table/interface';

export const formatCamMinutes = (minutes: number | null | undefined): string => {
	if (minutes === null || minutes === undefined) return '—';
	const rounded = Math.round(minutes);
	const h = Math.floor(rounded / 60);
	const m = rounded % 60;
	return h > 0 ? `${h}h ${m}m` : `${m}m`;
};

/**
 * Table sorter that keeps empty values at the bottom in both directions.
 * Ant Design flips the comparator's result for descending order, so the
 * empty-value result is flipped back here.
 */
export const compareNullsLast = (
	a: number | null,
	b: number | null,
	sortOrder?: SortOrder,
): number => {
	const flip = sortOrder === 'descend' ? -1 : 1;
	if (a === null && b === null) return 0;
	if (a === null) return flip;
	if (b === null) return -flip;
	return a - b;
};
